import React from 'react';

import { makeStyles } from '@material-ui/core';
import { ReactComponent as Icon } from '#web-components/assets/icons/calendar.svg';
import styles from './CalendarIcon.styles';

const useStyles = makeStyles(styles, { name: 'CalendarIcon' });

export default function CalendarIcon() {
  const classes = useStyles();
  return (
    <Icon className={classes.calendarIcon} />
  );
}
